var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItems({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4107 4.02115C19.7666 4.16353 20 4.50825 20 4.8916V15.7185C20 16.1018 19.7666 16.4465 19.4107 16.5889L10.3482 20.2139C10.1247 20.3033 9.87533 20.3033 9.65182 20.2139L0.589321 16.5889C0.233392 16.4465 0 16.1018 0 15.7185V4.8916C0 4.50825 0.233392 4.16353 0.589321 4.02115L9.30364 0.535382C9.30749 0.533842 9.31134 0.532316 9.3152 0.530803L9.65182 0.396155C9.87533 0.306751 10.1247 0.30675 10.3482 0.396155L10.6848 0.530816C10.6887 0.532325 10.6925 0.533847 10.6964 0.535382L19.4107 4.02115ZM13.0046 2.80501L5.3125 5.88185L2.30791 4.68001L1.25 5.10317V5.60314L9.375 8.85314V18.7569L10 19.0069L10.625 18.7569V8.85314L18.75 5.60314V5.10317L17.6921 4.68001L10 7.75685L6.99536 6.55499L14.6875 3.47816L13.0046 2.80501Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 5.80384C20 4.70764 17.5 5.80384 20 4.70764V15.7174C20 16.1007 19.7666 16.4454 19.4107 16.5878L10.3482 20.2128C10.1247 20.3022 9.87533 20.3022 9.65182 20.2128L0.589321 16.5878C0.233392 16.4454 0 16.1007 0 15.7174V4.89051C0 4.50717 0.233392 4.16244 0.589321 4.02007L9.30364 0.534295C9.3342 0.560067 9.24222 0.495761 9.3152 0.529715L0.589321 4.02007C0.669737 3.9879 0.812831 3.93066 0.589321 4.02007L6.5 6.80384C6.50385 6.80535 9.99616 8.30426 10 8.30579L11 8.69287L17.5 5.80384Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItems);
export default __webpack_public_path__ + "static/media/Items.baf40415e40905c606c2384f46490522.svg";
export { ForwardRef as ReactComponent };